const productTypes = {
    CREATE_PRODUCT_ACTION: "CREATE_PRODUCT_ACTION",
    GET_LIST_PRODUCT_ACTION: "GET_LIST_PRODUCT_ACTION",
    GET_INIT_PRODUCT_ACTION: "GET_INIT_PRODUCT_ACTION",
    GET_DETAIL_PRODUCT_ACTION: "GET_DETAIL_PRODUCT_ACTION",
    UPDATE_PRODUCT_ACTION: "UPDATE_PRODUCT_ACTION",
    CLEAR_PRODUCT_ACTION: "CLEAR_PRODUCT_ACTION",
    CREATE_PRODUCT_SUCCESS: "CREATE_PRODUCT_SUCCESS",
    GET_INIT_PRODUCT_SUCCESS: "GET_INIT_PRODUCT_SUCCESS",
    GET_LIST_PRODUCT_SUCCESS: "GET_LIST_PRODUCT_SUCCESS",
    GET_DETAIL_PRODUCT_SUCCESS: "GET_DETAIL_PRODUCT_SUCCESS",
    UPDATE_PRODUCT_SUCCESS: "UPDATE_PRODUCT_SUCCESS",
    CREATE_PRODUCT_FAILED: "CREATE_PRODUCT_FAILED",
    GET_INIT_PRODUCT_FAILED: "GET_INIT_PRODUCT_FAILED",
    GET_LIST_PRODUCT_FAILED: "GET_LIST_PRODUCT_FAILED",
    GET_LIST_PRODUCT_ALL_FAILED: "GET_LIST_PRODUCT_ALL_FAILED",
    GET_DETAIL_PRODUCT_FAILED: "GET_DETAIL_PRODUCT_FAILED",
    UPDATE_PRODUCT_FAILED: "UPDATE_PRODUCT_FAILED"
}

export default productTypes;